import { motion } from "framer-motion"
import { ArrowRight } from "lucide-react"
import { Button, buttonVariants } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils/cn"
import type { Platform } from "@/data/platforms"

interface PlatformCardProps {
  platform: Platform
  index: number
}

/** 平台入口项：navy 收尾色块上的重复项，不是嵌套卡片。 */
export function PlatformCard({ platform, index }: PlatformCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3, delay: index * 0.08 }}
      className="flex flex-col items-center text-center"
    >
      <div className="w-12 h-12 rounded-full bg-inverse-ink/10 flex items-center justify-center mb-5">
        <platform.icon className="w-6 h-6 text-inverse-ink" />
      </div>

      <h3 className="text-heading-sm text-inverse-ink mb-2">{platform.name}</h3>
      <p className="text-body text-inverse-ink/70 mb-6 flex-grow">
        {platform.description}
      </p>

      <div className="mt-auto flex flex-col items-center gap-3">
        {platform.badge && (
          <Badge variant="neutral" className="bg-inverse-ink/10 text-inverse-ink/80">
            {platform.badge}
          </Badge>
        )}

        {platform.comingSoon ? (
          <Button variant="secondary" disabled>
            {platform.action}
          </Button>
        ) : platform.link ? (
          <a
            href={platform.link}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(buttonVariants({ variant: "secondary" }))}
          >
            {platform.action}
            <ArrowRight className="w-4 h-4" />
          </a>
        ) : (
          <span className="inline-flex items-center h-11 px-5 rounded-md border border-inverse-ink/40 text-label text-inverse-ink">
            {platform.action}
          </span>
        )}
      </div>
    </motion.div>
  )
}
